'use strict';

const pushLfbNews = {
    els: null,

    init: function () {
        this.els = document.querySelectorAll('.f-pushLfbNews');
        if (!this.els || this.els.length === 0) return;

        this.els.forEach(el => {
            const endpoint = el.getAttribute('data-api_endpoint');
            const contentContainer = el.querySelector('.f-pushLfbNews__content');
            const noresults = el.getAttribute('data-noresults') ? el.getAttribute('data-noresults') : "No results";

            if (!endpoint || !contentContainer) return;

            fetch(endpoint)
                .then(response => response.json())
                .then(data => {
                    const items = data.items;
                    if (!items || items.length === 0) {
                        contentContainer.innerHTML = `<p>${noresults}</p>`;
                        return;
                    }

                    const html = items.map(item => `
                        <a href="${item.link.url}" class="c-button text--" title="${item.link.title}" target="${item.link.target}">
                            <div class="c-push horizontal2--">
                                <div class="c-push__container">
                                    <div class="c-push__content">
                                        <div class="c-push__txt">
                                            <h3 class="c-push__title">${item.title}</h3>
                                            <p>${item.excerpt}</p>
                                        </div>
                                        <p class="c-push__date c-date small--"><span class="c-date__day">${item.date.day} ${item.date.month}</span><span class="c-date__year">${item.date.year}</span></p>
                                    </div>
                                    <div class="c-push__img c-img">
                                        <div class="figure">
                                            <picture>
                                                <img loading="lazy" src="${item.image.url}" alt="${item.image.alt}" />
                                            </picture>
                                        </div>
                                    </div>
                                </div>
                                <div class="c-push__link"><span class="c-button__elt"><span>${item.link.title}</span><i class="icon-arrow-externe" aria-hidden="true"></i></span></div>
                            </div>
                        </a>
                    `).join('');


                    contentContainer.innerHTML = html;
                })
                .catch(err => {
                    console.error('Failed to fetch news:', err);
                    contentContainer.innerHTML = '<p>Error loading news.</p>';
                });
        });
    },
};

export default pushLfbNews;
